import { EventNames } from '@farmasiet/frontendcore-reactcomponents';

export class RecommendationsEventNameResolver {
    public static GetEventName(widgetName: string): string {
        return EventNames.RecommendationsLoaded + widgetName;
    }
}
